import React, { useContext, useEffect, useState } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../store';
import { IClub } from '../../../store/player/clubs/store';

import userIcon from '../../../assets/images/player-blank.svg';
import { darkWaglLogo, menuIcon } from '../../../assets/images';
import { PX } from '../../../contrib/ui';
import { useBoolean } from '../../../scenes/common/Hooks/useBoolean.hook';
import { PlayerSideMenu } from './Components/PlayerSideMenu/PlayerSideMenu';
import { Button } from '../../Button/Button';
import useLocation from '../../../contrib/Hooks/useLocation.hook';

interface IProps {
  clubId: number;
}

const goToSettings = () => navigate('/profile/settings');

const goToLogin = () => navigate('/login');

const PlayerHeader = (props: IProps) => {
  const { clubId } = props;

  const { clubs, user } = useContext(GlobalContext);

  const {
    location: { pathname: currentRoute }
  } = useLocation();

  const [menuOpen, setMenuOpen, toggleMenuOpen] = useBoolean(false);

  const closeMenu = () => setMenuOpen(false);

  const toggleMenu = () => toggleMenuOpen();

  const isHome = currentRoute.includes('/home');

  const [title, setTitle] = useState<string>();

  const [club, setClub] = useState<IClub>();

  useEffect(() => setClub(clubs.all[Number(clubId)]), [clubs]);

  useEffect(() => {
    setTitle(club && club.name !== title ? club.name : '');
  }, [club]);

  return (
    <>
      <div className={`player-header ${isHome ? 'player-header--home' : ''}`}>
        <Button
          color="primary"
          className="menu"
          aria-haspopup="true"
          id="toggle-menu"
          onClick={toggleMenu}
        >
          <img
            src={menuIcon}
            className="player-header-icon override"
            height={18 * PX}
            width={18 * PX}
            alt="Menu"
          />
        </Button>

        <h1 className="title">
          {title || <img src={darkWaglLogo} alt="WAGL" className="player-header-logo" />}
        </h1>

        <Button
          color="primary"
          className="account"
          onClick={user.id !== 0 ? goToSettings : goToLogin}
        >
          {user.id !== 0 ? (
            <img
              src={userIcon}
              className="player-header-icon override"
              height={27 * PX}
              width={27 * PX}
              alt="User avatar"
            />
          ) : (
            'Login'
          )}
        </Button>
      </div>

      <PlayerSideMenu clubId={Number(clubId)} onClose={closeMenu} open={menuOpen} />
    </>
  );
};

export { PlayerHeader };
